import React from 'react'
import { MDBRadio } from 'mdb-react-ui-kit'

export const AdditionalCarrierFilter = ({ onChange, value }) => {
  const filterOptions = ['ALL', 'HEALTH', 'SENIOR', 'LIFE']
  return (
    <div className='float-right pr-1 me-4 font-weight-normal h6'>
      {filterOptions.map(option => (
        <MDBRadio
          key={option}
          inline
          name='additional-carrier-filter'
          id={`option-${option}`}
          label={option}
          value={option}
          checked={value === option}
          onChange={() => onChange(option)}
          wrapperClass='me-2'
        />
      ))}
    </div>
  )
}
